import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import { isAfisCyprus, isMedicycle } from 'shared-pages/common/constants';
import i18next from 'i18next';

const gqlGetValues = gql`
  query getRegions($where: String, $offset: Int, $limit: Int, $order: String) {
    getRegions(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: id
        description: name
      }
      recordCount
    }
  }
`;

export function useGetRegionAsOptionsQuery() {
  return useLazyQuery(gqlGetValues, {
    fetchPolicy: 'cache-first',
  });
}

function useGetRegionLazyQuery() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

// interface LcFsProps extends FsProps {
//   size?: 'sm' | 'lg';
// }

const regionTitle = isAfisCyprus || isMedicycle ? 'Επαρχία' : 'Περιφέρεια';

export const FieldSelectRegion = ({
  label = i18next.t(regionTitle),
  name = 'regionId',
  defaultValues = {},
  // size = 'sm',
  ...rest
}: FsProps) => {
  //const where = JSON.stringify({ isActive: true });
  return (
    <FieldSelectDB
      // height={size === 'lg' ? 32 : '22'}
      {...rest}
      label={label}
      name={name}
      sbLabel={(defaultValues as any)?.region?.name ?? undefined}
      //where={where}
      hook={useGetRegionLazyQuery}
    />
  );
};

